module.exports = __webpack_public_path__ + "img/turned-on-light-crane.8a432bc0.jpg";